"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarContent = exports.SideBarWrap = void 0;
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const createJourneyComponent_1 = require("../../lib/createJourneyComponent");
exports.SideBarWrap = createJourneyComponent_1.createJourneyComponent('j-side-bar-wrap', 'div');
exports.SideBarContent = createJourneyComponent_1.createJourneyComponent('j-side-bar-content', 'div');
const SideBar = (props) => (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)),
    react_1.default.createElement(exports.SideBarContent, { overwrite: { children: props.children } }, props.children)));
exports.default = withJourney_1.default('j-side-bar', SideBar);
